const globals = {
  menuOpen: false,
  windowOpen: false,
};

export default globals;
